import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

/**
 * Ribbon achievements dell'utente loggato (primaUscita, instancabile, ecc.).
 * Estratto da DashboardPage. Self-contained: fetch + render.
 */
interface AchData {
  primaUscita: { earned: boolean; progress: number; target: number };
  instancabile: { earned: boolean; progress: number; target: number };
  macchinaDaFuoco: { earned: boolean; progress: number; target: number };
  veterano: { earned: boolean; progress: number; target: number };
  nottambulo: { earned: boolean; progress: number; target: number };
}

/**
 * Achievement PER ANNO: il ribbon segue l'anno selezionato dal filtro della
 * dashboard (badge guadagnati in QUELL'anno). Anno nella queryKey per non
 * servire dalla cache i dati di un altro anno.
 */
export function AchievementsRibbon({ year }: { year: number }): React.JSX.Element {
  const { data } = useQuery<AchData>({
    queryKey: ['achievements', year],
    queryFn: async () => (await api.get('/interventions/achievements', { params: { year } })).data,
  });
  if (!data) return <div style={{ minHeight: 12 }} />;

  // Classi colorate come legacy: arancione (default), bronze, silver, gold, night.
  // Ordine come da foto Bryan: Prima Uscita > Instancabile > Macchina da Fuoco > Veterano > Nottambulo.
  const medals = [
    { key: 'primaUscita', label: '🎖️ Prima Uscita', cls: '', ach: data.primaUscita },
    { key: 'instancabile', label: '💪 Instancabile', cls: 'bronze', ach: data.instancabile },
    { key: 'macchinaDaFuoco', label: '🔥 Macchina da Fuoco', cls: 'silver', ach: data.macchinaDaFuoco },
    { key: 'veterano', label: '⭐ Veterano', cls: 'gold', ach: data.veterano },
    { key: 'nottambulo', label: '🌙 Nottambulo', cls: 'night', ach: data.nottambulo },
  ].filter(m => m.ach.earned);

  if (medals.length === 0) return <div style={{ minHeight: 12 }} />;

  return (
    <div style={{ textAlign: 'center', margin: '15px 0', display: 'flex',
                  justifyContent: 'center', gap: 10, flexWrap: 'wrap' }}>
      {medals.map(m => (
        <span key={m.key} className={`achievement-badge ${m.cls}`}>{m.label}</span>
      ))}
    </div>
  );
}

